/**
 * @file
 * Behaviors for the Hero Carousel.
 */
/* eslint-disable max-len */

!((document, Drupal, $) => {
  /*eslint strict: ["error", "never"]*/
  /**
   * Setup and attach the Hero Carousel behaviors.
   *
   * @type {Drupal~behavior}
   */
  Drupal.behaviors.heroCarousel = {
    attach: function () {
      this.colorboxHeroCarousel();
      this.slickHeroCarousel();
    },
    slickHeroCarousel: function () {
      $('.hero-carousel__slick')
        .not('.slick-initialized')
        .slick({
          dots: true,
          infinite: true,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1,
          responsive: [
            {
              breakpoint: 1033,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });

      // Make slides equal heights
      $('.hero-carousel__slick').on('setPosition', function (event, slick) {
        $(slick.$slides)
          .height('auto')
          .css('height', $(slick.$slideTrack).height() + 'px');
      });
    },
    colorboxHeroCarousel: function (context) {
      $('.hero-carousel-item__media', context).colorbox({
        opacity: 0.9,
        rel: 'hero-carousel'
      });

      // Customize colorbox dimensions
      var colorboxResize = function (resize) {
        var width = '90%';
        var height = '90%';

        if ($(window).width() > 960) {
          width = '860';
        }
        if ($(window).height() > 700) {
          height = '630';
        }

        $.colorbox.settings.height = height;
        $.colorbox.settings.width = width;

        //if window is resized while lightbox open
        if (resize) {
          $.colorbox.resize({
            height: height,
            width: width
          });
        }
      };

      // Make colorbox overlay responsive.
      $.colorbox.settings.onLoad = function () {
        colorboxResize();
      };

      //In case of window being resized
      $(window).resize(function () {
        colorboxResize(true);
      });
    }
  };
})(document, Drupal, jQuery);
